import { ConsolidationDefinitionDTO } from "../DTO/consolidationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateConsolidationDefinitionRequest extends BasicRequest{
   
    public consolidationDefinition! : ConsolidationDefinitionDTO;
    
    constructor(){
        super()
    }
}